import { Title } from '@gerdau/hefesto/Title';
import React from 'react';
import { IDuplicateState } from '../../../../store/ducks/dashboard/types';
import { DashboardItemContainer } from '../../styles';
import DuplicatesChart from './DuplicatesChart';

interface IDuplicatesProps {
  duplicatesState: IDuplicateState;
  errorMessageBlock: React.ReactNode;
}

const Duplicates: React.FC<IDuplicatesProps> = ({
  duplicatesState,
  errorMessageBlock,
  children
}) => {
  return (
    <DashboardItemContainer className="squared duplicates">
      <Title level={4}>Total de duplicatas (R$)</Title>

      {duplicatesState.error && !duplicatesState.loading && (
        <>{errorMessageBlock}</>
      )}

      {duplicatesState.loading && !duplicatesState.error && <>{children}</>}

      {!duplicatesState.error && !duplicatesState.loading && (
        <DuplicatesChart duplicatesState={duplicatesState} />
      )}
    </DashboardItemContainer>
  );
};

export default Duplicates;
